import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { clientMaster } = stateEnum

const initialState = {
  selectedClient: {},
   detailParams: {},
  isNewEntry: false
}

const clientMasterSlice = createSlice({
  name: clientMaster,
  initialState,
  reducers: {
    resetClientMaster: (state) => {
      state.selectedClient = []
    },
    setSelectedClient: (state, action) => {
      state.selectedClient = action.payload
    },
      setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetail: (state) => {
      state.detailParams = {};
      state.isNewEntry = true;
    },
    setIsNewEntry:(state,action)=>{
      state.isNewEntry=action.payload
    }
  },
})

export const { resetClientMaster, setSelectedClient ,setDetailParams,resetDetail,setIsNewEntry} =
  clientMasterSlice.actions
export default clientMasterSlice.reducer
